import React from 'react'
import { useState } from 'react'

export const useSelectedTableItems = () => {
  const [selectedItems, setSelectedItems] = useState([])

  const handleSelected = (items) => {
    let mappedItems = items.map(item => item.original)
    setSelectedItems(mappedItems)
  }


  return {
    selectedItems,
    handleSelected
  }
}
